import React, { useState } from 'react';
import { Container, Typography } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddParticipants from './components/AddParticipants';
import SetRulesPage from './components/SetRulesPage';
import YourSecret from './components/YourSecret';

function App() {
  const [participants, setParticipants] = useState([]);
  const [step, setStep] = useState('addParticipants');

  // Dynamisk: kan ta valfritt steg
  const handleContinue = (nextStep) => {
    setStep(nextStep);
  };

  return (
    <Router>
      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Dammers Secret Santa 🎅
        </Typography>

        <Routes>
          {/* Standardflöde */}
          <Route
            path="/"
            element={
              <>
                {step === 'addParticipants' && (
                  <AddParticipants
                    participants={participants}
                    setParticipants={setParticipants}
                    onContinue={() => handleContinue('setRules')}
                  />
                )}

                {step === 'setRules' && (
                  <SetRulesPage
                    participants={participants}
                    onBack={() => handleContinue('addParticipants')}
                    onGenerate={(blacklists) => {
                      console.log(
                        'Generera pairings med blacklist:',
                        blacklists
                      );
                      // här kan du anropa backend eller generera pairings lokalt
                    }}
                  />
                )}

                {step === 'review' && <div>Review page placeholder</div>}
              </>
            }
          />

          {/* /your-secret route */}
          <Route path="/your-secret" element={<YourSecret />} />
        </Routes>
      </Container>
    </Router>
  );
}

export default App;
